import { type PropsWithChildren } from "react";
import { cn } from "ui";

interface BillingIntervalOptionProps extends PropsWithChildren {
  active: boolean;
  onClick: () => void;
}

export function BillingIntervalOption(props: BillingIntervalOptionProps) {
  return (
    <button
      type="button"
      onClick={props.onClick}
      className={cn(
        "cursor-pointer rounded-md px-4 py-1.5 text-sm transition-colors",
        {
          "bg-szt-black text-white": props.active,
          "text-gray-700 hover:bg-gray-50": !props.active,
        },
      )}
    >
      {props.children}
    </button>
  );
}
